import AppRoutes from "./Routes";
import Copyrights from "./components/Copyrights";
import "./App.css";
import RoyalPurpleBox from "./components/RoyalPurpleBox";

function App() {
  return (
    <div className="app" stage-name={process.env.REACT_APP_STAGE_NAME}>
      <div className="header">
        <div className="logo">
          <img src="/unilever-logo-blue.png" alt="unilever logo" />
        </div>
      </div>
      <RoyalPurpleBox />
      <div className="content">
        <div className="main-column">
          <AppRoutes />
        </div>
      </div>
      <div className="footer">
        <div className="logo">
          <img src="/unilever-logo-white.png" alt="unilever logo footer" />
          <Copyrights />
        </div>
      </div>
    </div>
  );
}

export default App;
